import { useQuery } from '@tanstack/react-query';

import { toCamelCase } from '@/lib/case';

import { useAuthAxios } from '@/hooks/useAuthAxios';

export interface BinderFolder {
    code: string;
    name: string;
    isLocked: boolean;
}

export function useBinderFolders({ isEnabled = true }: { isEnabled?: boolean } = {}) {
    const { client, enabled } = useAuthAxios();

    return useQuery({
        queryKey: ['binderFolders'],
        retry: 2,
        queryFn: async () => {
            const response = await client.get('/api/leasing/folders');
            return toCamelCase<BinderFolder[]>(response.data);
        },
        enabled: enabled && isEnabled,
        staleTime: Infinity,
    });
}
